import { render, staticRenderFns } from "./NewProjectTopBar.vue?vue&type=template&id=284c9a49&scoped=true"
import script from "./NewProjectTopBar.vue?vue&type=script&lang=ts"
export * from "./NewProjectTopBar.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectTopBar.vue?vue&type=style&index=0&id=284c9a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c9a49",
  null
  
)

export default component.exports